import React from 'react';
import MainTermsUse from '../../components/Main/MainPolicy/MainTermsUse';

export default function TermsUse(){
    return(
        <div>
           <MainTermsUse />
        </div>
    )
}
